import type { SVGProps } from 'react';
const SvgViewCompact = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#view_compact_svg__a)">
      <path
        fill="currentColor"
        d="M3 19h6v-7H3v7Zm7 0h12v-7H10v7ZM3 5v6h19V5H3Z"
      />
    </g>
    <defs>
      <clipPath id="view_compact_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgViewCompact;
